import { render, staticRenderFns } from "./SalesmanPayrollTable.vue?vue&type=template&id=21c88db6&"
import script from "./SalesmanPayrollTable.vue?vue&type=script&lang=js&"
export * from "./SalesmanPayrollTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports